import { render, staticRenderFns } from "./VacationsReportManagement.vue?vue&type=template&id=1ca13998&scoped=true"
import script from "./VacationsReportManagement.vue?vue&type=script&lang=js"
export * from "./VacationsReportManagement.vue?vue&type=script&lang=js"
import style0 from "./VacationsReportManagement.vue?vue&type=style&index=0&id=1ca13998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca13998",
  null
  
)

export default component.exports